<template>
    <div class="exam_paper_list">
        <div class="exam_paper_top flex FlexBetween">
            <div>我的试卷</div>
            <el-select v-model="listParams.subjectId" placeholder="全部" style="width: 130px">
                <el-option v-for="item in originSubjectList" :key="item.subjectId" :label="item.subjectName"
                    :value="item.subjectId" />
            </el-select>
        </div>
        <div v-if="testPaperList.length">
            <div class="test_paper_one pb-10 mb-15 flex Flexalign Flexbetween" v-for="(item, index) in testPaperList"
                :key="index">
                <el-image class="test_paper_cover_icon" :src="iconPath('test_paper_cover_icon.svg')"></el-image>
                <div class="paper_info flex-1 flex flexcolumn ml-15">
                    <div class="toverflow paper_name">{{ item.paperDocumentName }}</div>
                    <div class="paper_tag flex mt-10">
                        <div class="tag_one px-10 py-5 mr-10">
                            {{
                                gradeList.filter((sitem) => sitem.stageId == item.stageId)[0]
                                    ?.stageName
                            }}
                        </div>
                        <div class="tag_one px-10 py-5 mr-10">
                            {{
                                gradeList.filter((sitem) => sitem.gradeId == item.gradeId)[0]
                                    ?.gradeName
                            }}
                        </div>
                        <div class="tag_one px-10 py-5 mr-10">
                            {{
                                item.year
                            }}
                        </div>
                        <div class="tag_one px-10 py-5 mr-10">
                            {{
                                originSubjectList.filter(
                                    (sitem) => sitem.subjectId == item.subjectId
                                )[0]?.subjectName
                            }}
                        </div>
                    </div>
                    <div class="flex Flexalign paper_create mt-10">
                        <div>{{ $Moment(item.updateTime).format("MM-DD") }}发布</div>
                        <div class="ml-10">浏览量：{{ item.viewCount }}</div>
                        <div class="ml-10">下载量：{{ item.downloadCount }}</div>
                        <div class="ml-10">创建人：{{ item.createByName }}</div>
                    </div>
                </div>
                <div class="paper_difficult ml-10 flex flexcolumn FlexEnd FlexBetween">
                    <el-rate v-model="item.difficulty" disabled :max="7" size="small" />
                    <div class="btn_start cursor_pointer" @click="viewExamPaper(item)">
                        详情
                    </div>
                </div>
            </div>
            <div class="pagination_box mar_top_20 flex FlexjustifyEnd" v-if="listTotal > listParams.pageSize">
                <el-pagination background layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40]"
                    :total="listTotal" v-model:page-size="listParams.pageSize" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" />
            </div>
        </div>
        <div v-else>
            <moe-empty url="moe_empty_bg_img.png" emptyText="暂无试卷"></moe-empty>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: 'GjkcH5ExamPaperList',
    computed: {
        ...mapState({
            originSubjectList: (state) => state.filter.subjectList,
            gradeList: (state) => state.filter.gradeList,
            stageList: (state) => state.filter.stageList,
        }),
    },

    data() {
        return {
            listParams: {
                subjectId: '',
                page: 1,
                pageSize: 10,
            },
            testPaperList: [],
        };
    },

    mounted() {
        this.getMyPaperList();
    },

    methods: {
        handleSizeChange() {
            this.getMyPaperList();
        },
        handleCurrentChange(value) {
            this.listParams.page = value;
            this.getMyPaperList();
        },
        // 获取测评列表
        getMyPaperList() {
            this.$Api.examination.getMyPaperList(this.listParams).then(res => {
                this.testPaperList = res.data.data?.list;
                this.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
            }).catch(() => { })
        },
        // 查看试卷
        viewExamPaper(info) {
            this.href("/examPaperView", { paperDocumentId: info.paperDocumentId })
        }
    },
};
</script>

<style lang="scss" scoped>
.exam_paper_list {
    min-height: 400px;

    .exam_paper_top {
        font-weight: 500;
        font-size: 16px;
        color: #303030;
    }

    .test_paper_one {
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);

        .test_paper_cover_icon {
            width: 82px;
            height: 92px;
        }

        .paper_info {
            // width: 300px;
            height: 90px;

            .paper_name {
                width: 100%;
                font-weight: 500;
                color: #303030;
                font-size: 14px;
            }

            .paper_tag {
                .tag_one {
                    background: #eff1f4;
                    border-radius: 4px;
                    font-size: 11px;
                    color: #606060;
                }
            }

            .paper_create {
                font-size: 12px;
                color: #606060;
            }
        }

        .paper_difficult {
            height: 80px;

            .btn_start {
                width: 91px;
                height: 32px;
                background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
                border-radius: 8px;
                text-align: center;
                line-height: 32px;
                font-size: 14px;
                color: #ffffff;
            }

            .paper_price {
                font-size: 14px;
                color: #FF6619;
                font-weight: 500;
            }
        }
    }
}
</style>